import { render } from "./Articles.vue?vue&type=template&id=71abe928&scoped=true&ts=true"
import script from "./Articles.vue?vue&type=script&lang=ts"
export * from "./Articles.vue?vue&type=script&lang=ts"

import "./Articles.vue?vue&type=style&index=0&id=71abe928&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71abe928"]])

export default __exports__